<template>
  <multiselect
    v-model="selected"
    @input="onChange"
    :options="options"
    :custom-label="labelUsuario"
    selectLabel=""
    selectedLabel="«"
    deselectLabel=""
    :allowEmpty="isMultiple ? true : false"
    :preselectFirst="isMultiple ? false : true"
    :loading="isLoading"
    label="nome"
    track-by="id"
    :disabled="isDisabled || isLoading"
    placeholder=""
    :multiple="isMultiple"
    :closeOnSelect="!isMultiple"
    :clearOnSelect="!isMultiple"
    :hideSelected="isMultiple"
    class="multiselect-primary"
  >
    <template slot="option" slot-scope="props">
      <div class="option__desc">
        <span class="option__title">{{ props.option.nome }}</span>
      </div>
    </template>
    <template slot="tag" slot-scope="props">
      <span class="multiselect__tag" :style="{ backgroundColor: 'var(--primary)' }">
        {{ props.option.nome }}
        <span class="multiselect__tag-icon" @click="props.remove(props.option)"></span>
      </span>
    </template>
    <template slot="noResult" slot-scope="props">
      <span>{{ $t('Nenhum elemento encontrado') }}.</span>
    </template>
    <template slot="noOptions" slot-scope="props">
      <span>{{ $t('Nenhum dado foi retornado') }}.</span>
    </template>
    <template slot="placeholder" slot-scope="props">
      <span>{{ $t(emptyLabel) }}</span>
    </template>
  </multiselect>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },
  props: [
    'nameField',
    'isRequired',
    'isDisabled',
    'emptyLabel',
    'includeAll',
    'filter',
    'localidadeSelected',
    'estabelecimentoSelected',
    'typeUserSelected',
    'removeItems',
    'filterBySite',
    'hidePausedUsers',
    'hideBlockedUsers',
    'inIdTipoUsuario',
    'isMultiple',
    'idSite'
  ],

  data() {
    return {
      selected: this.isMultiple ? [] : '',
      options: [],
      isLoading: false
    };
  },

  methods: {
    onChange(e) {
      this.$emit('input', e);
      if (this.isMultiple) {
        const ids = Array.isArray(e) ? e.map((item) => item.id) : [];
        this.$emit('selectChange', 'id_usuario_modelo', ids);
      } else {
        if (e == null) {
          this.$emit('selectChange', 'id_usuario_modelo', null);
          return;
        }
        this.$emit('selectChange', 'id_usuario_modelo', e.id);
      }
    },
    labelUsuario({ nome }) {
      return nome && `${nome}`;
    },
    setValue(value) {
      if (this.isMultiple) {
        if (Array.isArray(value) && value.length > 0) {
          this.selected = this.options.filter((option) => value.includes(option.id));
        } else {
          this.selected = [];
        }
      } else {
        let selectedActual = this.options.find((option) => option.id === value);
        if (value) {
          this.selected = selectedActual;
        } else {
          this.selected = this.options.find((option) => option.id === null);
          selectedActual = this.options.find((option) => option.id === null);
        }
      }
      this.onChange(this.selected);
      this.$emit('input', this.selected);
    },
    setOptions(localidadeSelected, estabelecimentoSelected) {
      this.isLoading = true;
      let filter = `id_empresa_auth=${this.$store.state.user.info.id_empresa} and `;
      if (this.filterBySite === true) {
        filter += `business_logic.usuario.domain_id=${this.localidadeSelected} and `;
      } else {
        if (localidadeSelected) filter += `business_logic.localidade.id=${localidadeSelected} and `;
        if (estabelecimentoSelected) filter += `business_logic.estabelecimento.id=${estabelecimentoSelected} and `;
        if (this.inIdTipoUsuario) {
          filter += `business_logic.usuario.id_tipo_usuario in (${this.inIdTipoUsuario}) and `;
        } else {
          if (this.typeUserSelected)
            filter += `business_logic.usuario.id_tipo_usuario=${this.typeUserSelected} and `;
        }
      }
      filter += `business_logic.usuario.excluido=false`;

      if (this.hidePausedUsers === true) {
        filter += ` and coalesce((business_logic.usuario.configuracao->>'emPausa')::boolean, false) is false`;
      }
      if (this.hideBlockedUsers === true) {
        filter += ` and business_logic.usuario.bloqueado = false `;
      }

      if (this.idSite) {
        filter += ` and business_logic.usuario.domain_id in (${this.idSite})`;
      }

      this.$atenaList
        .getUsuariosSite({
          columns: 'id_usuario_sp as id, nome, login',
          filter: filter,
          related: 'estabelecimento:id as id_estabelecimento|secao:id as id_secao|localidade:id as id_localidade',
          order: 'login desc',
          limit: -1
        })
        .then((res) => {
          this.options = [];
          if (this.includeAll) {
            this.options = [{ id: null, nome: this.$i18n.t(this.emptyLabel) }];
          }

          this.options = this.options.concat(
            res.data.map((item) => {
              return {
                ...item,
                nome: item.nome + ' - ' + item.login
              };
            })
          );

          if (this.nameField) {
            this.setValue(this.nameField);
          }
          this.removeOptions();
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.$notify({
            group: 'notifications-default',
            type: 'error',
            title: this.$i18n.t('Erro ao Carregar Dados'),
            text: this.$i18n.t('Entre em contato com o Administrador do Sistema.')
          });
        });
    },
    removeOptions() {
      if (this.removeItems?.length) {
        this.options = this.options.filter((option) => {
          return !this.removeItems.includes(option.id);
        });
      }
    }
  },

  created() {
    this.setOptions(this.localidadeSelected, this.estabelecimentoSelected);
  },

  watch: {
    localidadeSelected(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setOptions(newVal, null);
      }
    },
    estabelecimentoSelected(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setOptions(this.localidadeSelected, newVal);
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
